/// <amd-module name="SuiteCommerce.InventoryDisplay.Main"/>
define("SuiteCommerce.InventoryDisplay.Main", ["require", "exports", "SuiteCommerce.InventoryDisplay.Message.View", "SuiteCommerce.InventoryDisplay.Message.SpecialOrderItem.View", "SuiteCommerce.InventoryDisplay.Message.DropShipItem.View", "SuiteCommerce.InventoryDisplay.Message.RegularItem.View", "SuiteCommerce.InventoryDisplay.Website.Model", "SuiteCommerce.InventoryDisplay.Configuration", "SuiteCommerce.InventoryDisplay.Instrumentation", "SuiteCommerce.InventoryDisplay.Common.InstrumentationHelper"], function (require, exports, InventoryDisplay_Message_View_1, InventoryDisplay_Message_SpecialOrderItem_View_1, InventoryDisplay_Message_DropShipItem_View_1, InventoryDisplay_Message_RegularItem_View_1, InventoryDisplay_Website_Model_1, Configuration_1, Instrumentation_1, InstrumentationHelper_1) {
    "use strict";
    return {
        mountToApp: function mountToApp(container) {
            var _this = this;
            var pdp = container.getComponent('PDP');
            var environment = container.getComponent('Environment');
            var websiteId = environment.getSiteSetting('id');
            InstrumentationHelper_1.InstrumentationHelper.initializeInstrumentation(environment);
            var loadExtensionOnPDP = Instrumentation_1.default.getLog('loadView');
            loadExtensionOnPDP.startTimer();
            var websiteModel = new InventoryDisplay_Website_Model_1.WebsiteModel();
            var promise = websiteModel.fetch({
                data: {
                    websiteId: websiteId,
                },
            });
            promise.done(function () {
                loadExtensionOnPDP.endTimer();
                loadExtensionOnPDP.setParameters({
                    activity: 'Time it takes to load the website data',
                    totalTime: loadExtensionOnPDP.getElapsedTimeForTimer(),
                });
                loadExtensionOnPDP.submit();
            });
            Configuration_1.Configuration.environment = container.getComponent('Environment');
            if (pdp) {
                pdp.addChildView('Product.Stock.Info', function () {
                    var item = InventoryDisplay_Message_View_1.InventoryDisplayMessageView.getItemInfo(pdp);
                    var view;
                    if (item.itemtype !== 'InvtPart' && item.itemtype !== 'Assembly') {
                        return;
                    }
                    pdp.on('afterOptionSelection', function () {
                        _this.selectProperPrototypeForChild(view, InventoryDisplay_Message_View_1.InventoryDisplayMessageView.getItemInfo(pdp));
                    });
                    if (item.isspecialorderitem) {
                        view = new InventoryDisplay_Message_SpecialOrderItem_View_1.SpecialOrderItemMessageView({
                            pdp: pdp,
                            model: websiteModel,
                        });
                    }
                    else if (item.isdropshipitem) {
                        view = new InventoryDisplay_Message_DropShipItem_View_1.DropShipItemMessageView({
                            pdp: pdp,
                            model: websiteModel,
                        });
                    }
                    else {
                        view = new InventoryDisplay_Message_RegularItem_View_1.ItemMessageView({
                            pdp: pdp,
                            model: websiteModel,
                        });
                    }
                    promise.done(function () {
                        view.loaded();
                    });
                    return view;
                });
            }
        },
        selectProperPrototypeForChild: function (view, item) {
            if (item.isdropshipitem) {
                view.isInStock = InventoryDisplay_Message_DropShipItem_View_1.DropShipItemMessageView.prototype.isInStock;
                view.getStockMessage = InventoryDisplay_Message_DropShipItem_View_1.DropShipItemMessageView.prototype.getStockMessage;
            }
            else if (item.isspecialorderitem) {
                view.isInStock = InventoryDisplay_Message_SpecialOrderItem_View_1.SpecialOrderItemMessageView.prototype.isInStock;
                view.getStockMessage = InventoryDisplay_Message_SpecialOrderItem_View_1.SpecialOrderItemMessageView.prototype.getStockMessage;
            }
            else {
                view.isInStock = InventoryDisplay_Message_RegularItem_View_1.ItemMessageView.prototype.isInStock;
                view.getStockMessage = InventoryDisplay_Message_RegularItem_View_1.ItemMessageView.prototype.getStockMessage;
            }
        }
    };
});
